import { useSuspense } from "@api";
import type { ICerDates } from "@bbj-types/candidate/cer";
import type { ObjectId, Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { interviewExitAxiosInstance, useAxiosInterviewExit } from "../../axios";
import type { IInterviewExit, IInterviewExitCandidateChallenge, IInterviewExitCandidateObjective } from "../types";

export interface IGetInterviewExitDraft extends Omit<IInterviewExit, "challenges"> {
  neolinkCerToClose?: ICerDates;
  challenges: Override<
    IInterviewExitCandidateChallenge,
    {
      challenge: ObjectId;
      objectives: Override<
        IInterviewExitCandidateObjective,
        {
          objective: ObjectId;
        }
      >[];
    }
  >[];
}

export const useGetInterviewExitDraft = () => {
  const [state, execute, cancel] = useAxiosInterviewExit<IGetInterviewExitDraft>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId) =>
      execute({
        url: `/candidates/${candidateId}/interviews-exit/draft`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetInterviewExitDraftSuspense = (candidateId: ObjectId) =>
  useSuspense(
    () =>
      interviewExitAxiosInstance.get<IGetInterviewExitDraft>(`/candidates/${candidateId}/interviews-exit/draft`, {
        withCredentials: true,
      }),
    [candidateId]
  );
